import { useEffect, useState } from 'react'
import { fetchAllData } from '../services/compositions'

export function useCompositions() {
  const [data, setData] = useState({})
  const [imageMap, setImageMap] = useState(null)
  const [itemComponents, setItemComponents] = useState({})
  const [itemImageMap, setItemImageMap] = useState({})
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const json = await fetchAllData()
        setData(json.best_pairs)
        setImageMap(json.champion_weapon_images)
        setItemComponents(json.item_components ?? {})
        setItemImageMap(json.item_images ?? {})
      } catch (err) {
        console.error('Failed to fetch data:', err)
        setError(err)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [])

  return { data, imageMap, itemComponents, itemImageMap, loading, error }
}
